import Vapi from '@borisp/vuex-rest-api'
import { payloadToState, getOptimisticDelete } from 'utils/helpers'
import { VUE_APP_BASE_API_URL } from '../../constants/fileConstants'

export default new Vapi({
  baseURL: VUE_APP_BASE_API_URL,
  state: {
    videoQualities: [],
    videoQualitiesMetadata: {},
    videoQuality: {}
  }
})
  .get({
    action: 'getVideoQualities',
    property: 'videoQualities',
    path: '/video-qualities/',
    onSuccess: payloadToState('videoQualities')
  })
  .delete({
    action: 'deleteVideoQuality',
    property: 'videoQuality',
    path: ({ id }) => `/video-qualities/${id}`,
    onSuccess: payloadToState('videoQuality')
  })
  .post({
    action: 'createVideoQuality',
    property: 'videoQuality',
    path: '/video-qualities/',
    onSuccess: payloadToState('videoQuality')
  })
  .getStore()
